import React, { useCallback, useState } from 'react';
import SelectBox, { SelectBoxTypes } from 'devextreme-react/select-box';
import {
  Chart,
  Series,
  ArgumentAxis,
  CommonSeriesSettings,
  ICommonSeriesSettingsProps,
  Margin,
  Export,
  Legend,
} from 'devextreme-react/chart';

const types: (ICommonSeriesSettingsProps['type'])[] = ['splinearea', 'stackedsplinearea', 'fullstackedsplinearea'];

interface Props {
  title: string;
  array: any
}

function MsiSplineChart(props: Props) {
  const { title, array } = props;
  const [type, setType] = useState(types[0]);

  const handleChange = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
    setType(e.value);
  }, [setType]);

  return (
    <div id="chart-demo">
      <Chart
        palette="Harmony Light"
        title={title}
        dataSource={array}>
        <CommonSeriesSettings
          argumentField="company"
          type={type}
        />
        <Series valueField="y2005" name="2005"></Series>
        <Series valueField="y2004" name="2004"></Series>
        <ArgumentAxis valueMarginsEnabled={false} />
        <Legend
          verticalAlignment="bottom"
          horizontalAlignment="center"
        />
        <Margin bottom={20} />
        <Export enabled={true} />
      </Chart>
    </div>
  );
}

export default MsiSplineChart;
